import { buildSusIngestionsUrl } from '@/shared/utils/ingestion-url';
import { ActionIcon, Tooltip } from '@mantine/core';
import { IconHistory } from '@tabler/icons-react';
import { useTranslate } from '@tolgee/react';
import { Link } from 'react-router-dom';

type Props = {
  /** Id du service d'urgence dont on veut voir les ingestions. */
  id: number;
  /** Appelé au clic, avant la navigation (ex. pour fermer le panneau latéral). */
  onClick?: () => void;
};

/** Ouvre le tableau des ingestions filtré sur ce service d'urgence. */
const SusIngestionsButton = ({ id, onClick }: Props) => {
  const { t } = useTranslate();

  return (
    <Tooltip label={t('admin.sus.ingestions')} withArrow>
      <ActionIcon
        component={Link}
        to={buildSusIngestionsUrl(id)}
        onClick={onClick}
        variant="subtle"
        aria-label={t('admin.sus.ingestions')}
      >
        <IconHistory size={16} stroke={1.5} />
      </ActionIcon>
    </Tooltip>
  );
};

export default SusIngestionsButton;
